import { format } from 'date-fns';

export const formatDate = (date) => format(new Date(date), 'dd/MM/yyyy');

export const formatTime = (date) => format(new Date(date), 'hh:mm');

export const formatCurrencyAmount = (x) => (x ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
